import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ArticleIcon from '../../../../assets/icons/Article';
// import SkillsIcon from '../../../../assets/icons/Skills';
import ProjectIcon from '../../../../assets/icons/Project';
import OpenSourceIcon from '../../../../assets/icons/Opensource';

import classes from './ContentList.module.css';

class ContentList extends Component {
  state = {
    content: [
      { text: 'Projects', icon: <ProjectIcon style={{ marginRight: '12px' }} /> },
      { text: 'Open Source', icon: <OpenSourceIcon style={{ marginRight: '12px' }} /> },
      { text: 'Articles', icon: <ArticleIcon style={{ marginRight: '12px' }} /> }
      // { text: 'Skills', icon: <SkillsIcon style={{ marginRight: '12px' }} /> }
    ]
  };

  render() {
    const { content } = this.state;
    return (
      <ul>
        {content.map(item => {
          const path = `portfolio/${item.text.toLowerCase().replace(' ', '')}`;
          return (
            <li className={classes.ContentList} key={item.text}>
              <Link className={classes.Link} to={`/${path}`}>
                {item.icon}
                <p>{item.text}</p>
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default ContentList;
